/* eslint-disable */
(function subnavtab($, Drupal) {

  // function to change tab based by hash value.
  function changeTab($hash) {

    // Remove active tab class
    $('.hero-link--subnav').each(function() {
      $(this).removeClass('hero-sub-nav__link--active');
    })

    // When hash changes hide all content wells.
    $('.subnav-tab__content').hide();

    // Find the active tab.
    activeTab = $('.hero-link--subnav').filter(function(){
      return $(this).prop('href').indexOf($hash) != -1;
    });

    // Set the new tab as active
    activeTab.addClass('hero-sub-nav__link--active');

    // Using value show the well.
    $($hash).show();
  }

  // check if about page, (not ideal but we may need to do something else)
  // if (window.location.href.indexOf("about-us") > -1) {

  //   // On click of legacy links if there is a hash value.
  //   $('.hero-link--subnav').on('click', function() {
  //     $(window).on('hashchange',function(){ 

  //       changeTab(location.hash);
    
  //     });
  //   });


  //   // On load of legacy pages.
  //   $(document).ready(function() {

  //     let hash = '';

  //     if (location.hash) {
  //       hash = location.hash;
  //     } else {
  //       hash = '#overview';
  //     }
      
  //     changeTab(hash);

  //   });
  
  // }

}(jQuery, Drupal, drupalSettings));
/* eslint-enable */
